var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PeriodSectionBody } from '../common/periodSectionBody';
import { PeriodSectionTable } from '../common/periodSectionTable';
import { getLobExpansionKey, getMultiskillExpansionKeys, getMultiskillGroupExpansionKeys, getMultiskillSectionExpansionKey, getQueueExpansionKeysForLob, } from '../common/queueRow';
import { AGENT_REQUIREMENTS_ROWS } from '../constants';
export var AgentRequirementsTable = function (_a) {
    var data = _a.data, index = _a.index, addColumns = _a.addColumns, isProdHoursPlan = _a.isProdHoursPlan;
    var t = useTranslation('report', { keyPrefix: 'period' }).t;
    var lobs = React.useMemo(function () { var _a; return (_a = data.queuesByLob) !== null && _a !== void 0 ? _a : []; }, [data.queuesByLob]);
    var expansionItems = React.useMemo(function () { return __spreadArray(__spreadArray([], AGENT_REQUIREMENTS_ROWS, true), AGENT_REQUIREMENTS_ROWS.flatMap(function (item) {
        return lobs
            .flatMap(function (lob) { return __spreadArray([getLobExpansionKey(lob.lobName, item)], getQueueExpansionKeysForLob(lob, item), true); })
            .concat(getMultiskillExpansionKeys(data.queues, item));
    }), true); }, [data.queues, lobs]);
    var getNestedExpansionItems = React.useCallback(function (itemName) {
        if (AGENT_REQUIREMENTS_ROWS.includes(itemName)) {
            var rowItem_1 = itemName;
            return lobs
                .flatMap(function (lob) { return __spreadArray([getLobExpansionKey(lob.lobName, rowItem_1)], getQueueExpansionKeysForLob(lob, rowItem_1), true); })
                .concat(getMultiskillExpansionKeys(data.queues, rowItem_1));
        }
        var multiskillRowItem = AGENT_REQUIREMENTS_ROWS.find(function (item) { return itemName === getMultiskillSectionExpansionKey(item); });
        if (multiskillRowItem)
            return getMultiskillGroupExpansionKeys(data.queues, multiskillRowItem);
        var rowItem = AGENT_REQUIREMENTS_ROWS.find(function (item) { return itemName.startsWith("".concat(item, "::")); });
        if (!rowItem)
            return [];
        var lobEntry = lobs.find(function (lob) { return itemName === getLobExpansionKey(lob.lobName, rowItem); });
        if (!lobEntry)
            return [];
        return getQueueExpansionKeysForLob(lobEntry, rowItem);
    }, [data.queues, lobs]);
    return (_jsx(PeriodSectionTable, { title: t('agentRequirement'), data: data, index: index, addColumns: addColumns, isProdHoursPlan: isProdHoursPlan, expansionItems: expansionItems, defaultExpanded: false, tableBodyComponent: function (props) { return _jsx(PeriodSectionBody, __assign({}, props, { rowItem: AGENT_REQUIREMENTS_ROWS })); }, getNestedExpansionItems: getNestedExpansionItems }));
};
